<template>
    <div :style="calculStyleCellule" class="caseOptionBlocage">
      <div class="has-text-black has-text-right pd-5px">
        {{ qteFacesPrevues - nbFaceNonDispo }}
        / {{ qteFacesPrevues }}
      </div>
    </div>
</template>

<script>

import calculateStyleCelluleEtatObtenu from '@/services/planningReseauTempo/calculateStyleCelluleEtatObtenu';

export default {
  props: {
    qteFacesPrevues: {
      required: true,
      type: Number,
    },
    nbFaceNonDispo: {
      required: true,
      type: Number,
    },
    affectations: {
      required: true,
      type: Array,
    },
  },
  computed: {
    calculStyleCellule() {
      return calculateStyleCelluleEtatObtenu({
        allAffectationOfProduct: this.affectations,
        stock: this.qteFacesPrevues,
      });
    },
  },
};

</script>
